// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-post-js": require("gatsby-module-loader?name=component---src-templates-blog-post-js!/opt/build/repo/src/templates/blog-post.js"),
  "component---src-templates-tags-js": require("gatsby-module-loader?name=component---src-templates-tags-js!/opt/build/repo/src/templates/tags.js"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-tags-index-js": require("gatsby-module-loader?name=component---src-pages-tags-index-js!/opt/build/repo/src/pages/tags/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "rio-via-lison.json": require("gatsby-module-loader?name=path---rio-via-lison!/opt/build/repo/.cache/json/rio-via-lison.json"),
  "tags-travel.json": require("gatsby-module-loader?name=path---tags-travel!/opt/build/repo/.cache/json/tags-travel.json"),
  "tags-flights.json": require("gatsby-module-loader?name=path---tags-flights!/opt/build/repo/.cache/json/tags-flights.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "tags.json": require("gatsby-module-loader?name=path---tags!/opt/build/repo/.cache/json/tags.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js